import React, { Fragment, ReactNode } from 'react';

import { faFileInvoiceDollar } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Popover, PopoverButton, PopoverPanel, Transition } from '@headlessui/react';
import { ChevronRightIcon } from '@heroicons/react/24/outline';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';

import { classNames } from '@utils/classNames';

import messages from './messages';

interface SideNavTabProps {
  label: string | React.ReactElement;
  icon: ReactNode;
  isExpanded: boolean;
  isArrow?: boolean;
  selected?: boolean;
}

const ReportsNavItem = (props: SideNavTabProps) => {
  const { label, icon, isExpanded, isArrow, selected } = props;
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/reports/financialReport');
  };

  return (
    <Popover className="relative">
      <PopoverButton className="w-full outline-none">
        <div
          role="button"
          className={classNames(
            'flex items-center cursor-pointer  transition-all duration-500 p-3  rounded-full',
            isExpanded ? 'w-full' : 'w-12',
            selected ? 'bg-blue-100 pointer-events-none' : 'hover:bg-gray-100',
          )}
          data-testid={`label-${label}`}
          tabIndex={0}
        >
          <div className="w-6 h-6"> {icon}</div>
          <div
            className={classNames(
              'mr-auto ml-3 transition-all duration-1000',
              isExpanded ? 'opacity-100' : 'opacity-0',
            )}
          >
            <div className="text-sm text-gray-900 text-nowrap">{label}</div>
          </div>
          {isArrow && <ChevronRightIcon height={20} width={20} className="ml-auto text-gray-400" />}
        </div>
      </PopoverButton>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-10"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-10"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <PopoverPanel
          className={classNames(
            `absolute bg-white bottom-[-5px] z-50 ${isExpanded ? 'left-48 transition-all duration-300' : 'left-16 transition-all duration-300'}`,
          )}
        >
          <div className="border border-gray-200 w-52 rounded-md shadow-[0px_4px_24px_rgba(17,24,39,0.08)] cursor-pointer">
            <div className="pt-4 pb-3 px-4">
              <button className="text-sm gap-2 flex align-middle" onClick={handleClick}>
                <div className="w-6 h-6">
                  <FontAwesomeIcon icon={faFileInvoiceDollar} className="w-5 h-5" />
                </div>
                <FormattedMessage {...messages.financialReport} />
              </button>
            </div>
          </div>
        </PopoverPanel>
      </Transition>
    </Popover>
  );
};

export default ReportsNavItem;
